import React, { useState } from 'react';
import { MultiFactorAuthenticationType } from '../../../Infrastructure/API/MultiFactorAuthentication/list';
import EmailActivation from './EmailActivation';
import TotpActivation from './TotpActivation';

interface MultiFactorAuthenticationActivationProps {
  onGoBackToLoginClick: () => void;
}

const MultiFactorAuthenticationActivation = ({ onGoBackToLoginClick }: MultiFactorAuthenticationActivationProps) => {
  const [activeAuthentication] = useState<MultiFactorAuthenticationType>(MultiFactorAuthenticationType.Email);

  return (
    <>
      {activeAuthentication === MultiFactorAuthenticationType.Email && (
        <EmailActivation onGoBackToLoginClick={onGoBackToLoginClick} />
      )}
      {activeAuthentication === MultiFactorAuthenticationType.TOTP && (
        <TotpActivation onGoBackToLoginClick={onGoBackToLoginClick} />
      )}
    </>
  );
};

export default MultiFactorAuthenticationActivation;
